<template>
  <div class="mask-container">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.mask-container {
  background-color: #fbfbfb;
  mix-blend-mode: hard-light;
}
</style>
